import axios from './financeiroApi';

const transferenciaApi = () => {
  const getPath = () => {
    return `/api/v1/backend/transferencia`;
  };

  return {
    buscar: async (id) => {
      const url = `${getPath()}/${id}`;
      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json; charset=utf8',
          Accept: 'application/json; charset=utf8',
        },
        responseType: 'json',
      });
    },

    buscarTodas: async (search) => {
      const url = `${getPath()}`;

      return axios.get(
        url,
        { params: search },
        {
          headers: {
            'Content-Type': 'application/json; charset=utf8',
            Accept: 'application/json; charset=utf8',
          },
          responseType: 'json',
        }
      );
    },

    cadastrar: async (params) => {
      const url = `${getPath()}`;
      return axios.post(url, params, {
        headers: {
          'Content-Type': 'application/json; charset=utf8',
          Accept: 'application/json; charset=utf8',
        },
        responseType: 'json',
      });
    },

    atualizar: async (params) => {
      const url = `${getPath()}`;
      return axios.put(url, params, {
        headers: {
          'Content-Type': 'application/json; charset=utf8',
          Accept: 'application/json; charset=utf8',
        },
        responseType: 'json',
      });
    },

    excluir: async (params) => {
      const url = `${getPath()}`;
      return axios.delete(url, { data: params });
    },

    desconciliar: async (id) => {
      const url = `${getPath()}/desconciliar/${id}`;
      return axios.put(url, undefined, {
        headers: {
          'Content-Type': 'application/json; charset=utf8',
          Accept: 'application/json; charset=utf8',
        },
        responseType: 'json',
      });
    },
  };
};

export default transferenciaApi;
